"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUrl = void 0;
const isValidUrl = (url) => {
    try {
        const urlLocal = new URL(url);
        return urlLocal.protocol === "http:" || urlLocal.protocol === "https:";
    }
    catch (ignore) {
        const urlPattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/\\?#[\]@!$&'()*+,;=.]+$/gm;
        return !!url.match(urlPattern);
    }
};
exports.isValidUrl = isValidUrl;
